import React from "react";
import CampaignForm from "../components/campaigns/CampaignForm";
import { EmptyState, Link, ScreenContainer } from "../components/wombat-ui";
import useTranslations from "../hooks/useTranslations";

import useViewer from "../hooks/useViewer";

type NewCampaignProps = Record<string, never>;

const NewCampaign: React.FC<NewCampaignProps> = () => {
  const t = useTranslations();
  const { isCapableOfInsertingCampaigns } = useViewer();

  return isCapableOfInsertingCampaigns ? (
    <CampaignForm />
  ) : (
    <ScreenContainer
      error={
        <EmptyState
          title={t("network.unauthorized") as string}
          action={
            <Link to="/" variant="button">
              {t("network.backToHome")}
            </Link>
          }
        />
      }
    />
  );
};

export default React.memo(NewCampaign);
